// Improved boat storage script with better organization
document.addEventListener('DOMContentLoaded', () => {
    const SELECTORS = {
        contactButtons: '[data-boat-name][data-boat-id][data-bs-target="#modalContact"]',
        legacyButtons: '.click-track[data-info-click="contact_form_open"]:not([data-boat-name])'
    };

    const STORAGE_KEYS = {
        boatName: 'boatName',
        boatId: 'boatID'
    };

    const storeBoatInfo = (boatName, boatId) => {
        localStorage.setItem(STORAGE_KEYS.boatName, boatName);
        localStorage.setItem(STORAGE_KEYS.boatId, boatId);
    };

    const clearBoatInfo = () => {
        localStorage.removeItem(STORAGE_KEYS.boatName);
        localStorage.removeItem(STORAGE_KEYS.boatId);
    };

    // Handle modern buttons with boat data
    document.querySelectorAll(SELECTORS.contactButtons).forEach(button => {
        button.addEventListener('click', () => {
            const boatName = button.getAttribute('data-boat-name');
            const boatId = button.getAttribute('data-boat-id');

            if (boatName && boatId) {
                storeBoatInfo(boatName, boatId);
            }
        });
    });

    // Handle legacy buttons
    document.querySelectorAll(SELECTORS.legacyButtons).forEach(button => {
        button.addEventListener('click', clearBoatInfo);
    });
});
